module.exports = __webpack_public_path__ + "img/ufa-bet-support.053868af.png";